import React from "react";
import { EuiBadge } from "@elastic/eui";
import "./styles.css";

export const MultiSociedadCellRenderer = (params: any) => {
  if (params.node.rowPinned) {
    return null;
  }

  const multi = params.data.multiplesSociedades;

  let iconState = multi === 1 || multi;

  const getIsMulti = () => {
    return (
      <EuiBadge color="secondary" className="badgeCell">{"multisociedad"}</EuiBadge>
    );
  };

  const getIsNotMulti = () => {
    return (
      <p style={{lineHeight:"26px"}}>{params.value}</p>
      // <EuiBadge color="#ffffff" className="badgeCell">{params.value}</EuiBadge>
    );
  };
  
  return iconState ? getIsMulti() : getIsNotMulti();
};